'use client';
import React, { useState } from 'react';
import { SessionContext } from '@benzinga/session-context';
import { useActiveWorkspaceSubscriber } from '@benzinga/pro-tools';
import { Security, Quote, QuoteFeedEvent, QuotesV3Manager } from '@benzinga/quotes-v3-manager';

export const useQuoteSubscription = (symbol: Security, fields: Set<keyof Quote>): Quote | undefined => {
  const [quotes, setQuotes] = useState<Quote | undefined>(undefined);
  useQuoteSubscriptionCallback(symbol, fields, setQuotes);
  return quotes;
};

export const useQuoteSubscriptionCallback = (
  symbol: Security,
  fields: Set<keyof Quote>,
  callback: (quote: Quote | undefined) => void,
) => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesV3Manager);

  const feed = React.useMemo(() => {
    const feed = quotesManager.createQuoteFeed(symbol);
    callback(feed.getQuote());
    return feed;
  }, [callback, quotesManager, symbol]);

  useActiveWorkspaceSubscriber(
    feed as any,
    (event: QuoteFeedEvent) => {
      switch (event.type) {
        case 'quote':
          callback(feed.getQuote());
          break;
      }
    },
    fields,
  );
};
